// common string constants, to avoid circular dependencies
export const keyFindingLabelPrescriptionRequest = 'Prescription request';
export const keyFindingLabelReview = 'Review of cough';
